import React, { useState, createElement } from 'react';
import { Activity, Search, Filter, Download, Terminal, AlertTriangle, ServerCrash, CreditCard, Zap, User } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
import { Pagination } from '../ui/Pagination';
interface AdminAuditLogProps {
  success: (msg: string) => void;
}
export function AdminAuditLog({
  success
}: AdminAuditLogProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const auditLogs = [{
    id: 'LOG-8921',
    user: 'admin@astriqo.com',
    action: 'Изменение цены услуги',
    object: 'SRV-001 (Натальная карта)',
    date: 'Сегодня, 14:32',
    ip: '192.168.1.45',
    type: 'update'
  }, {
    id: 'LOG-8920',
    user: 'support@astriqo.com',
    action: 'Блокировка пользователя',
    object: 'User ID: 8492',
    date: 'Сегодня, 13:15',
    ip: '10.0.0.12',
    type: 'danger'
  }, {
    id: 'LOG-8919',
    user: 'manager@astriqo.com',
    action: 'Возврат платежа',
    object: 'Order ID: ORD-5512',
    date: 'Сегодня, 11:40',
    ip: '192.168.1.88',
    type: 'warning'
  }, {
    id: 'LOG-8918',
    user: 'admin@astriqo.com',
    action: 'Изменение AI шаблона',
    object: 'Template: Solar Return v2',
    date: 'Вчера, 18:20',
    ip: '192.168.1.45',
    type: 'update'
  }, {
    id: 'LOG-8917',
    user: 'content@astriqo.com',
    action: 'Публикация статьи',
    object: 'Post ID: 142',
    date: 'Вчера, 15:10',
    ip: '10.0.0.34',
    type: 'create'
  }, {
    id: 'LOG-8916',
    user: 'support@astriqo.com',
    action: 'Удаление отзыва',
    object: 'Review ID: 992',
    date: 'Вчера, 12:05',
    ip: '10.0.0.12',
    type: 'danger'
  }, {
    id: 'LOG-8915',
    user: 'admin@astriqo.com',
    action: 'Авторизация в системе',
    object: 'System',
    date: 'Вчера, 09:00',
    ip: '192.168.1.45',
    type: 'info'
  }];
  const systemLogs = [{
    id: 'SYS-551',
    type: 'error',
    source: 'Payment Gateway',
    message: 'Stripe API timeout during charge creation',
    date: 'Сегодня, 15:40',
    code: 'ERR_TIMEOUT'
  }, {
    id: 'SYS-550',
    type: 'warning',
    source: 'AI Engine',
    message: 'High latency detected in OpenAI API response (>5s)',
    date: 'Сегодня, 14:12',
    code: 'WARN_LATENCY'
  }, {
    id: 'SYS-549',
    type: 'error',
    source: 'Database',
    message: 'Deadlock found when trying to get lock; try restarting transaction',
    date: 'Сегодня, 11:05',
    code: 'ERR_DEADLOCK'
  }, {
    id: 'SYS-548',
    type: 'info',
    source: 'Cron Job',
    message: 'Daily subscription renewals completed successfully (142 processed)',
    date: 'Сегодня, 03:00',
    code: 'INFO_CRON'
  }, {
    id: 'SYS-547',
    type: 'error',
    source: 'Email Service',
    message: 'Failed to send welcome email to user@example.com: Invalid recipient',
    date: 'Вчера, 22:15',
    code: 'ERR_SMTP'
  }];
  const getActionBadge = (type: string) => {
    switch (type) {
      case 'danger':
        return <Badge variant="error" size="sm" data-id="element-2423">
            Критично
          </Badge>;
      case 'warning':
        return <Badge variant="warning" size="sm" data-id="element-2424">
            Внимание
          </Badge>;
      case 'update':
        return <Badge variant="pro" size="sm" data-id="element-2425">
            Изменение
          </Badge>;
      case 'create':
        return <Badge variant="success" size="sm" data-id="element-2426">
            Создание
          </Badge>;
      default:
        return <Badge variant="neutral" size="sm" data-id="element-2427">
            Инфо
          </Badge>;
    }
  };
  const getSourceIcon = (source: string) => {
    if (source.includes('Payment')) return <CreditCard className="w-4 h-4 text-rose-500" data-id="element-2428" />;
    if (source.includes('AI')) return <Zap className="w-4 h-4 text-amber-500" data-id="element-2429" />;
    if (source.includes('Database')) return <ServerCrash className="w-4 h-4 text-rose-600" data-id="element-2430" />;
    return <Terminal className="w-4 h-4 text-slate-500" data-id="element-2431" />;
  };
  const filteredLogs = auditLogs.filter(log => {
    const matchesSearch = log.user.toLowerCase().includes(searchQuery.toLowerCase()) || log.action.toLowerCase().includes(searchQuery.toLowerCase()) || log.object.toLowerCase().includes(searchQuery.toLowerCase());
    if (!matchesSearch) return false;
    if (filterType !== 'all' && log.type !== filterType) return false;
    return true;
  });
  const handleExport = () => {
    const headers = ['Log ID', 'Пользователь', 'Действие', 'Объект', 'IP Адрес', 'Дата', 'Тип'];
    const rows = filteredLogs.map(log => [log.id, log.user, log.action, log.object, log.ip, log.date, log.type]);
    const csvContent = [headers.join(','), ...rows.map(r => r.map((v: any) => `"${String(v).replace(/"/g, '""')}"`).join(','))].join('\n');
    const blob = new Blob(['\uFEFF' + csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `audit_logs_export_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    success(`Экспорт ${filteredLogs.length} логов завершён`);
  };
  const auditTab = <div className="space-y-4" data-id="element-2432">
      <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-2433">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-2434">
          <div className="flex items-center gap-3 w-full sm:w-auto flex-1" data-id="element-2435">
            <div className="relative flex-1 max-w-md" data-id="element-2436">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-2437" />
              <input type="text" placeholder="Поиск по пользователю, действию, объекту..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2438" />
            </div>
            <select className="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-2439">
              <option value="all" data-id="element-2440">Все действия</option>
              <option value="danger" data-id="element-2441">Критичные</option>
              <option value="update" data-id="element-2442">Изменения</option>
              <option value="create" data-id="element-2443">Создание</option>
              <option value="warning" data-id="element-2444">Предупреждения</option>
              <option value="info" data-id="element-2445">Инфо</option>
            </select>
          </div>
          <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-2447" />} onClick={handleExport} data-id="element-2446">
            Экспорт CSV
          </Button>
        </div>
      </Card>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-2448">
        <div className="overflow-x-auto" data-id="element-2449">
          <table className="w-full text-left" data-id="element-2450">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-2451">
              <tr data-id="element-2452">
                <th className="px-4 py-3 font-medium" data-id="element-2453">Log ID</th>
                <th className="px-4 py-3 font-medium" data-id="element-2454">Пользователь (Админ)</th>
                <th className="px-4 py-3 font-medium" data-id="element-2455">Действие</th>
                <th className="px-4 py-3 font-medium" data-id="element-2456">Объект</th>
                <th className="px-4 py-3 font-medium" data-id="element-2457">IP Адрес</th>
                <th className="px-4 py-3 font-medium" data-id="element-2458">Дата</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-2459">
              {filteredLogs.map(log => <tr key={log.id} className="hover:bg-slate-50" data-id="element-2460">
                  <td className="px-4 py-3 text-xs text-slate-500 font-mono" data-id="element-2461">
                    {log.id}
                  </td>
                  <td className="px-4 py-3" data-id="element-2462">
                    <div className="flex items-center gap-2" data-id="element-2463">
                      <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center" data-id="element-2464">
                        <User className="w-3 h-3 text-slate-500" data-id="element-2465" />
                      </div>
                      <span className="text-sm font-medium text-slate-900" data-id="element-2466">
                        {log.user}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-2467">
                    <div className="flex items-center gap-2" data-id="element-2468">
                      {getActionBadge(log.type)}
                      <span className="text-sm text-slate-700" data-id="element-2469">
                        {log.action}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-2470">
                    {log.object}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-500 font-mono" data-id="element-2471">
                    {log.ip}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-600" data-id="element-2472">
                    {log.date}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t border-slate-100 flex justify-center" data-id="element-2473">
          <Pagination currentPage={currentPage} totalPages={5} onPageChange={setCurrentPage} data-id="element-2474" />
        </div>
      </Card>
    </div>;
  const systemTab = <div className="space-y-4" data-id="element-2475">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4" data-id="element-2476">
        <Card padding="sm" className="rounded-xl shadow-none border-slate-200 bg-rose-50/50 border-rose-100" data-id="element-2477">
          <div className="text-xs text-rose-600 font-bold mb-1" data-id="element-2478">
            Ошибки (24ч)
          </div>
          <div className="text-2xl font-bold text-rose-700" data-id="element-2479">12</div>
        </Card>
        <Card padding="sm" className="rounded-xl shadow-none border-slate-200 bg-amber-50/50 border-amber-100" data-id="element-2480">
          <div className="text-xs text-amber-600 font-bold mb-1" data-id="element-2481">
            Предупреждения (24ч)
          </div>
          <div className="text-2xl font-bold text-amber-700" data-id="element-2482">45</div>
        </Card>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-2483">
        <div className="overflow-x-auto" data-id="element-2484">
          <table className="w-full text-left" data-id="element-2485">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-2486">
              <tr data-id="element-2487">
                <th className="px-4 py-3 font-medium" data-id="element-2488">Уровень</th>
                <th className="px-4 py-3 font-medium" data-id="element-2489">Источник</th>
                <th className="px-4 py-3 font-medium" data-id="element-2490">Сообщение</th>
                <th className="px-4 py-3 font-medium" data-id="element-2491">Код</th>
                <th className="px-4 py-3 font-medium" data-id="element-2492">Дата</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-2493">
              {systemLogs.map(log => <tr key={log.id} className="hover:bg-slate-50" data-id="element-2494">
                  <td className="px-4 py-3" data-id="element-2495">
                    <Badge variant={log.type === 'error' ? 'error' : log.type === 'warning' ? 'warning' : 'neutral'} size="sm" data-id="element-2496">
                      {log.type.toUpperCase()}
                    </Badge>
                  </td>
                  <td className="px-4 py-3" data-id="element-2497">
                    <div className="flex items-center gap-2 text-sm font-medium text-slate-900" data-id="element-2498">
                      {getSourceIcon(log.source)}
                      {log.source}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-slate-700 max-w-md truncate" title={log.message} data-id="element-2499">
                    {log.message}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-500 font-mono" data-id="element-2500">
                    {log.code}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-600" data-id="element-2501">
                    {log.date}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-2502">
      <div data-id="element-2503">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-2504">Журналы системы</h2>
        <p className="text-sm text-slate-500" data-id="element-2505">
          Аудит действий администраторов и системные логи (Audit Log)
        </p>
      </div>

      <Tabs tabs={[{
      id: 'audit',
      label: 'Журнал действий (Audit Log)',
      content: auditTab
    }, {
      id: 'system',
      label: 'Системные логи',
      content: systemTab
    }]} data-id="element-2506" />
    </div>;
}